// src/layouts/Carousel_slider/Carousel_slider.jsx

import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import './swiper.css';
import './swiper-bundle.css'; // Updated import for Swiper styles

const CarouselSlider = () => {
  
  const slides = [
    {
      title: "Ayushman Bharat Digital Mission (ABDM) with Modules M1, M2, and M3",
      subtitle: "The Ayushman Bharat Digital Mission aims to create a comprehensive digital health ecosystem in India. The integration of various modules enhances the delivery of healthcare services, improving accessibility, interoperability, and patient management.",
      imgSrc: "assets/images/Carousole/Abha.png",
      link: "https://abdm.gov.in/",
      buttonText: "Learn More",
      imgStyle: { width: '490px', height: '401px', objectFit: 'cover' } // Individual style
    },
    {
      title: "ITSC Technologies Pvt. Ltd",
      subtitle: "With 25 years in healthcare Technology, ITSC Technology Pvt. Ltd. is a trusted provider of HMIS solutions, combining advanced software, robust hardware, and dedicated support. Our motto, ‘Your Trust, Our Commitment,’ reflects our focus on reliable, innovative solutions that empower healthcare providers to deliver exceptional patient care.",
      imgSrc: "assets/images/Carousole/logo25.png",
      link: "https://www.itscglobal.com/",
      buttonText: "Visit ITSC"
    },
    {
      title: "HMIS (e-Sehat)",
      subtitle: "e-Sehat HMIS (Health Management Information System) is a comprehensive digital solution aimed at improving healthcare delivery. It facilitates efficient data collection, management, and reporting, enabling healthcare providers to enhance patient care, streamline operations, and make informed decisions based on real-time information.",
      imgSrc: "assets/images/Carousole/HMIS.png"
    },
    {
      title: "Material management",
      subtitle: "Material management involves the systematic planning and control of materials and supplies within an organization. It includes procurement, inventory management, storage, and distribution, ensuring efficient resource utilization, cost reduction, and streamlined operations to support timely delivery and enhance overall productivity.",
      imgSrc: "assets/images/Carousole/MaterialManagment.png"
    },
    {
      title: "Medical Record Department (MRD)",
      subtitle: "The Medical Record Department (MRD) is responsible for managing patient health records in healthcare facilities. This department ensures accurate documentation, storage, and retrieval of medical records, maintaining confidentiality and compliance with regulations. It plays a crucial role in patient care, billing, and quality assurance, facilitating communication among healthcare providers.",
      imgSrc: "assets/images/Carousole/RegistrationID.png"
    },
    {
      title: "LIS (Laboratory Information System) and RIS (Radiology Information System)",
      subtitle: (
        <>
          LIS: A system for managing laboratory data, including test orders, results, and workflow, enhancing accuracy and communication in healthcare.<br />
          <br />
          RIS: A system for managing radiology information, handling scheduling, imaging orders, and reporting, streamlining processes and improving patient care.
        </>
      ),
      imgSrc: "assets/images/Carousole/medicalID.png"
    },
    {
      title: "Reporting and Analytics in Healthcare",
      subtitle: "Reporting and analytics in healthcare involve analyzing clinical data to identify trends, improve patient outcomes, and optimize operational efficiency, enabling informed decision-making and enhancing overall quality of care.",
      imgSrc: "assets/images/Carousole/phr.png",
      link: "#pricing04-o",
      buttonText: "More Modules"
    }
  ];

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <Swiper spaceBetween={50} slidesPerView={1} pagination={{ clickable: true }}>
              {slides.map((slide, index) => (
                <SwiperSlide key={index}>
                  <div className="d-flex flex-column flex-md-row">

                    <div className="col-12 col-md-6" style={{ textAlign: "left", marginTop: "10%" , padding:"20px" }}>
                      <h2 className="text-gradient h1-large">{slide.title}</h2>
                      <span className="subtitle p-large">{slide.subtitle}</span>
                      {slide.link && (
                        <div>
                          <a className="btn btn-primary" style={{ padding: '0.25rem 2rem' }} href={slide.link}>
                            {slide.buttonText || "Read More"} {/* Use custom button text or default to "Read More" */}
                          </a>
                        </div>
                      )}
                    </div>

                    <div className="col-12 col-md-6" style={{ textAlign: "right" , padding: "75px" }}>
                      <img
                        src={slide.imgSrc}
                        alt={slide.title}
                        title={slide.title}
                        style={slide.imgStyle}
                        className="img-fluid carousel-image" // Added carousel-image class
                      />
                    </div>

                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </>
  );
};

export default CarouselSlider;
